module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "toc-ttl"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter02#pz9-2_1",
      "id": "pz9-2"
    }
  }, [_c('i', [_vm._v("Foreword by Duane “Dog the Bounty Hunter” Chapman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#A49_1",
      "id": "A49"
    }
  }, [_c('b', [_vm._v("Chapter 1")]), _vm._v(" Take Up Serpents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#AWQ_1",
      "id": "AWQ"
    }
  }, [_c('b', [_vm._v("Chapter 2")]), _vm._v(" The Religious Spirit and Idols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#AqN_1",
      "id": "AqN",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3")]), _vm._v(" Snakes Hate Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#AFX_1",
      "id": "AFX",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4")]), _vm._v(" The Antivenom Power of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#pz9-3_1",
      "id": "pz9-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5")]), _vm._v(" Shaking Off Venomous Vipers Through Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#pz9-5_1",
      "id": "pz9-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6")]), _vm._v(" Leviathan: The King of the Children of Pride")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#pz9-7_1",
      "id": "pz9-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 7")]), _vm._v(" Trauma, Leviathan, and Witchcraft")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#pz9-8_1",
      "id": "pz9-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 8")]), _vm._v(" Python Squeezes Out Your Gains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#pz9-9_1",
      "id": "pz9-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 9")]), _vm._v(" Healing and Deliverance From Idols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#pz9-10_1",
      "id": "pz9-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 10")]), _vm._v(" Fertility and Food")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#pz9-11_1",
      "id": "pz9-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 11")]), _vm._v(" Commissioned to Be a Snake Hunter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#pz9-12_1",
      "id": "pz9-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bm#pz9-13_1",
      "id": "pz9-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a647aa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-toc.vue
// module id = 69
// module chunks = 0